import React from 'react';

const AccountAdminContext = React.createContext({});

export default AccountAdminContext;
